import React from "react";
import styled from "@emotion/styled";
import { CircularProgress, Typography } from "@mui/material";

const Root = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const Text = styled(Typography)`
  margin-top: 20px;
`;

function Loader() {
  return (
    <Root>
      <CircularProgress size={50} />
      <Text variant="h4">Loading Results...</Text>
    </Root>
  );
}

export default Loader;
